export const STATUSES = [
  { value: "active", label: "Active" },
  { value: "requested", label: "Requested" },
  { value: "dormant", label: "Dormant" },
];

export const CATEGORIES = [
  "Perfume / Fragrance",
  "Beauty / Cosmetics",
  "Hair / Care",
  "IT / Electronics",
  "Mixed assortment",
];

export const COUNTRIES = [
  "Germany",
  "Netherlands",
  "Poland",
  "Spain",
  "Italy",
  "France",
  "Czechia",
  "UAE",
  "Other",
];

export const COUNTRY_FLAGS = {
  Germany: "🇩🇪",
  Netherlands: "🇳🇱",
  Poland: "🇵🇱",
  Spain: "🇪🇸",
  Italy: "🇮🇹",
  France: "🇫🇷",
  Czechia: "🇨🇿",
  UAE: "🇦🇪",
  Other: "🏳️",
};

export const LIST_SOURCES = {
  "Email on request": {
    icon: "✉",
    color: "#f0a92b",
    fields: [
      ["email_address", "Email address"],
      ["request_cadence", "Request cadence"],
    ],
  },
  "Email automatic": {
    icon: "✉",
    color: "#1e9e6a",
    fields: [
      ["sender_address", "Sender address"],
      ["send_cadence", "Send cadence"],
    ],
  },
  "Website login": {
    icon: "⌂",
    color: "#2f6fed",
    fields: [
      ["login_url", "Login URL"],
      ["username", "Username"],
      ["list_path", "Path to price list"],
    ],
  },
  "API / Interface": {
    icon: "⚡",
    color: "#7c5cf0",
    fields: [
      ["endpoint", "Endpoint"],
      ["auth_method", "Auth method"],
      ["rate_limit", "Rate limit"],
    ],
  },
  "FTP feed": {
    icon: "⇵",
    color: "#2aa9c9",
    fields: [
      ["host", "Host"],
      ["path", "Path / filename"],
      ["pickup_time", "Pickup time"],
    ],
  },
  WhatsApp: {
    icon: "◍",
    color: "#1e9e6a",
    fields: [
      ["phone", "Phone"],
      ["contact", "Contact person"],
    ],
  },
  "Sales rep / in person": {
    icon: "☎",
    color: "#8b9ab8",
    fields: [
      ["rep_name", "Sales rep name"],
      ["visit_cadence", "Visit cadence"],
    ],
  },
};

export const PAYMENT_TERMS = [
  "Prepaid",
  "Net 7 days",
  "Net 14 days",
  "Net 30 days",
];

export const PRICE_LEVELS = [
  { value: "A", label: "A – very good" },
  { value: "B", label: "B – market average" },
  { value: "C", label: "C – expensive" },
];

export const GOODS_TYPES = [
  "Clean EU",
  "Tester",
  "Deco / Dummy",
  "Mixed",
  "Unclear",
];

export const YES_NO_OPTIONS = ["Yes", "No", "Partial", "Check"];

export const emptyForm = () => ({
  company_name: "",
  country: "Germany",
  category: "Perfume / Fragrance",
  status: "active",
  website: "",
  contact_name: "",
  email: "",
  list_source: "Email on request",
  source_details: {},
  min_order_value: "",
  payment_terms: "Prepaid",
  price_level: "B",
  goods_type: "Clean EU",
  brands: "",
  note: "",
  customer_number: "",
  owner: "",
  ean_in_list: "Check",
  dropshipping: "Check",
  amazon_invoice_ok: "Check",
  last_contact_at: "",
  activated_since: "",
});

export const toApiPayload = (form) => ({
  company_name: form.company_name.trim(),
  country: form.country,
  category: form.category || null,
  status: form.status,
  website: form.website?.trim() || null,
  contact_name: form.contact_name?.trim() || null,
  email: form.email?.trim() || null,
  list_source: form.list_source,
  source_details: form.source_details || {},
  min_order_value:
    form.min_order_value === "" || form.min_order_value == null
      ? null
      : Number(form.min_order_value),
  payment_terms: form.payment_terms || null,
  price_level: form.price_level || null,
  goods_type: form.goods_type || null,
  brands: form.brands,
  note: form.note?.trim() || null,
  customer_number: form.customer_number?.trim() || null,
  owner: form.owner?.trim() || null,
  ean_in_list: form.ean_in_list || null,
  dropshipping: form.dropshipping || null,
  amazon_invoice_ok: form.amazon_invoice_ok || null,
  last_contact_at: form.last_contact_at || null,
  activated_since: form.activated_since || null,
});

export const fromApiRow = (row) => ({
  ...emptyForm(),
  ...row,
  brands: Array.isArray(row.brands) ? row.brands.join(", ") : row.brands || "",
  min_order_value:
    row.min_order_value === null || row.min_order_value === undefined
      ? ""
      : row.min_order_value,
  source_details: row.source_details || {},
  last_contact_at: row.last_contact_at || "",
  activated_since: row.activated_since || "",
});

export const statusLabel = (status) =>
  STATUSES.find((s) => s.value === status)?.label || status;

export const formatMoq = (value) => {
  if (value === null || value === undefined || value === "") return null;
  return `${Number(value).toLocaleString("de-DE")} €`;
};
